<ng-content class="bc-content-body"></ng-content>